import React, { FC } from 'react';
import { Title } from '../developers/page-components/Title';
import { useContactsContext } from '../../store/contacts/contacts-context';

export const ContactInformation: FC = () => {
	const { contactsContextState } = useContactsContext();
	const { contactDetails } = contactsContextState;

	const infoFields = [
		{
			title: 'MerchantContactPage name',
			value: `${contactDetails?.firstName} ${contactDetails?.lastName}`
		},
		{
			title: 'Email',
			value: contactDetails?.email
		},
	];

	return (
		<div className="card mb-5">
			<div className="card-body">
				<Title title="MerchantContactPage information" additionalClass="fs-5 fw-bolder" />
				{infoFields.map(el => (
					<div key={el?.title} className="mt-2">
						<div className="fs-8 text-muted">
							{el?.title}
						</div>
						<div className="fs-7">
							{el?.value}
						</div>
					</div>
				))}
			</div>
		</div>
	);
};
